import AddIcon from '@mui/icons-material/AddOutlined';
import { LinkButton } from 'framework/ui/ui-builder';
import { useAuthorization } from 'framework/authorization';

interface CreateButtonProps {
  url: string | ((id?: Nullable<StringOrNumber>) => string);
  permissionToCheck: string | string[];
}

const UploadEmployeeExpensesButton = ({ url, permissionToCheck, ...props }: CreateButtonProps) => {
  const { isGranted } = useAuthorization();

  return isGranted(permissionToCheck) ? (
    <LinkButton
      {...props}
      url={url}
      className="button create-btn"
      color="primary"
      onClick={(e: any) => {
        e.stopPropagation();
      }}
      variant="outlined"
      startIcon={<AddIcon />}
    >
      Upload worker expenses
    </LinkButton>
  ) : null;
};

export default UploadEmployeeExpensesButton;
